<template>
    <div class="login-page">
        <!-- 使用背景动画组件 -->
        <BackgroundAnimation :particleCount="particleCount" />
        <div class="content">
            <div class="login-container">
                <div class="login-header">
                    <div class="logo-icon">🌊</div>
                    <h1 class="login-title">{{ title }}</h1>
                    <p class="login-subtitle">地下管网数字化长效服务系统</p>
                </div>

                <form @submit.prevent="handleSubmit">
                    <div class="form-group">
                        <label class="form-label" for="username">用户名</label>
                        <input
                            type="text"
                            id="username"
                            v-model="username"
                            class="form-input"
                            placeholder="请输入用户名"
                            @focus="clearError('username')"
                            required
                        >
                        <div v-if="errors.username" class="error-msg" id="usernameError">{{ errors.username }}</div>
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="password">密码</label>
                        <input
                            type="password"
                            id="password"
                            v-model="password"
                            class="form-input"
                            placeholder="请输入密码"
                            @focus="clearError('password')"
                            required
                        >
                        <div v-if="errors.password" class="error-msg" id="passwordError">{{ errors.password }}</div>
                    </div>

                    <div class="form-options">
                        <div class="checkbox-wrapper">
                            <input type="checkbox" id="remember" name="remember" v-model="rememberMe">
                            <label for="remember">记住我</label>
                        </div>
                        <a href="#" class="forgot-link">忘记密码？</a>
                    </div>

                    <button type="submit" class="login-btn">
                        <span v-if="isLogin">登录中...</span>
                        <span v-else>
                            登 录
                        </span>
                    </button>
                </form>

<!--                <div class="other-login">-->
<!--                    <div class="divider">-->
<!--                        <span>其他登录方式</span>-->
<!--                    </div>-->
<!--                    <div class="social-login">-->
<!--                        <div class="social-btn" title="微信登录" @click="socialLogin('wechat')">📱</div>-->
<!--                        <div class="social-btn" title="钉钉登录" @click="socialLogin('dingtalk')">💼</div>-->
<!--                        <div class="social-btn" title="政务通登录" @click="socialLogin('gov')">🏛️</div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
import BackgroundAnimation from '@/components/water-affairs-style/backgroundAnimation.vue';
import { login } from "@/api/login";
import encrypt from "@/utils/encrypt";
export default {
    name: 'LoginPage',
    components: {
        BackgroundAnimation
    },
    data() {
        return {
            title: '盱眙网数达智慧管网平台',
            username: '',
            password: '',
            rememberMe: false,
            errors: {
                username: '',
                password: ''
            },
            particleCount: 30,
            isLogin:false,
        }
    },
    created() {
        this.updateTitle();
    },
    methods: {
        updateTitle() {
            const titleParam = this.$route.query.title;
            if (titleParam) {
                this.title = titleParam;
                localStorage.setItem('title', titleParam)
            }
        },
        clearError(field) {
            this.errors[field] = '';
        },
        handleSubmit() {
            let hasError = false;

            // 验证用户名
            if (this.username.length < 3) {
                this.errors.username = '用户名至少3个字符';
                hasError = true;
            } else {
                this.errors.username = '';
            }

            // 验证密码
            if (this.password.length < 6) {
                this.errors.password = '密码至少6个字符';
                hasError = true;
            } else {
                this.errors.password = '';
            }

            if (!hasError) {
               this.isLogin = true;
                const params = {
                    name: this.username,
                    password: encrypt.encrypt(this.password),
                };

                login(params)
                    .then((res) => {
                        if (res && res.token && res.user) {
                            window.localStorage.setItem("token", res.token);
                            window.localStorage.setItem("user", JSON.stringify(res.user));
                            this.$router.push("/index");
                            setTimeout(() => {
                                this.isLogin = false;
                            }, 3000);
                        }
                    }) .catch((error) => {
                        console.error('登录失败:', error);
                        this.isLogin = false;
                    });
            }
        },
        socialLogin(type) {
            console.log(`使用${type}登录`);
            // 实际项目中这里应该是调用对应的社交登录API
        }
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
    background: #0a0e27;
    color: #fff;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    position: relative;
}
.content{
    width: 100%;
    justify-content: center;
    display: flex
}
/* 登录容器 */
.login-container {
    background: rgba(20, 35, 70, 0.5);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 20px;
    padding: 3rem;
    width: 100%;
    max-width: 420px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.login-container::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(45deg, #00ff96, #00d4ff, #00ff96);
    border-radius: 20px;
    opacity: 0;
    z-index: -1;
    transition: opacity 0.3s ease;
}

.login-container:hover::before {
    opacity: 0.3;
}

/* Logo区域 */
.login-header {
    text-align: center;
    margin-bottom: 2.5rem;
}

.logo-icon {
    font-size: 3rem;
    margin-bottom: 1rem;
    animation: float 3s ease-in-out infinite;
}

@keyframes float {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
}

.login-title {
    font-size: 1.8rem;
    font-weight: bold;
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 0.5rem;
}

.login-subtitle {
    color: #e6e6e6;
    font-size: 0.9rem;
}

/* 表单样式 */
.form-group {
    margin-bottom: 1.5rem;
}

.form-label {
    display: block;
    margin-bottom: 0.5rem;
    color: #94a3b8;
    font-size: 0.9rem;
}

.form-input {
    width: 100%;
    padding: 0.75rem 1rem;
    background: rgba(10, 20, 40, 0.6);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 10px;
    color: #fff;
    font-size: 1rem;
    transition: all 0.3s ease;
}

.form-input:focus {
    outline: none;
    border-color: #00ff96;
    background: rgba(10, 20, 40, 0.8);
    box-shadow: 0 0 20px rgba(0, 255, 150, 0.2);
}

.form-input::placeholder {
    color: #64748b;
}
.error-msg{
    color: #ee804a;
}

/* 记住我选项 */
.form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.checkbox-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.checkbox-wrapper input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.checkbox-wrapper label {
    color: #94a3b8;
    font-size: 0.9rem;
    cursor: pointer;
}

.forgot-link {
    color: #00ff96;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
}

.forgot-link:hover {
    color: #00d4ff;
    text-decoration: underline;
}

/* 登录按钮 */
.login-btn {
    width: 100%;
    padding: 1rem;
    background: linear-gradient(135deg, #00ff96, #00d4ff);
    border: none;
    border-radius: 10px;
    color: #0a0e27;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.login-btn::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
}

.login-btn:hover::before {
    width: 300px;
    height: 300px;
}

.login-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(0, 255, 150, 0.3);
}

/* 其他登录方式 */
.other-login {
    margin-top: 2rem;
    text-align: center;
}

.divider {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
}

.divider::before,
.divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: rgba(0, 255, 150, 0.2);
}

.divider span {
    color: #64748b;
    font-size: 0.9rem;
}

.social-login {
    display: flex;
    gap: 1rem;
    justify-content: center;
}

.social-btn {
    width: 40px;
    height: 40px;
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 50%;
    background: rgba(10, 20, 40, 0.6);
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.social-btn:hover {
    border-color: #00ff96;
    color: #00ff96;
    transform: translateY(-2px);
}

/* 粒子效果 */
.particles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: -1;
}

.particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: rgba(0, 255, 150, 0.5);
    border-radius: 50%;
    animation: particle-float 15s infinite;
}

@keyframes particle-float {
    0% {
        transform: translateY(100vh) translateX(0);
        opacity: 0;
    }
    10% {
        opacity: 1;
    }
    90% {
        opacity: 1;
    }
    100% {
        transform: translateY(-10vh) translateX(100px);
        opacity: 0;
    }
}
</style>